import { render, staticRenderFns } from "./IntervalClock.vue?vue&type=template&id=67c7c96a&"
import script from "./IntervalClock.vue?vue&type=script&lang=js&"
export * from "./IntervalClock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports